import React, {ReactElement} from 'react';
import {useTranslation} from 'react-i18next';

type DialogModalProps = {
  title: any;
  body?: ReactElement;
};

const DialogModalBody: React.FC<DialogModalProps> = ({title, body}) => {
  const {t} = useTranslation();

  return (
    <>
      <div className=" relative  z-[1]">
        <div className="flex justify-center">
          <h3 className="text-xl font-barlowRegular text-white">{title}</h3>
        </div>
        <div className="hidden">
          <p className="mb-8 font-barlowLight uppercase text-2xl text-white">
            {t('Common.completed')}!
          </p>
        </div>
      </div>

      <div className="max-sm:h-[322px] max-md:h-[380px] h-[435px] w-full md:w-[360px] relative left-0 z-0">
        <div className="flex justify-center">{body}</div>
      </div>
    </>
  );
};
export default DialogModalBody;
